import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-material.css";
import { useCallback, forwardRef } from "react";
import Button from "@mui/material/Button";

import Box from "@mui/material/Box";

ModuleRegistry.registerModules([AllCommunityModule]);

const ERPGrid = forwardRef<AgGridReact, React.PropsWithChildren<any>>(
  ({ gridHeight, gridWidth, exportToExcel, ...gridProps }, ref) => {
    const onBtnExport = useCallback(() => {
      if (ref && "current" in ref && ref.current) {
        ref.current.api.exportDataAsCsv();
      }
    }, []);

    return (
      <Box
        className="ag-theme-material"
        sx={{
          width: gridWidth || "100%",
          height: gridHeight || "80vh",
          "& .ag-header-row": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
          "& .ag-row-odd": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
          "& .ag-row-hover": {
            cursor: "pointer",
            fontWeight: "bold",
          },
        }}
      >
        <Box display={"flex"} justifyContent={"flex-start"}>
          {exportToExcel && (
            <Button variant="outlined" onClick={onBtnExport} sx={{ mb: 1 }}>
              Export to Excel
            </Button>
          )}
        </Box>
        <AgGridReact ref={ref} {...gridProps} />
      </Box>
    );
  }
);

export default ERPGrid;
